import React from 'react';
import {Button, Form, Input, Modal, notification, Row, Select, Switch, Typography} from "antd";
import ApiService from "../../../services/ApiService"
import PermissionAlert from "../../../components/permissions/PermissionAlert";
import ContactIcon from "../../../components/util-components/ContactIcon";
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;

export default class ModalHazkara extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initialState = {
        visible: false,
        loading: false,
        edit: false,
        defaultData: {},
        id: null,
        contactId: null,
        contacts: []
    };

    state = this.initialState

    async init() {
        var res = await ApiService.get("/contact/form")
        this.setState({
            contacts: res.data.filter(
                i => !i.deceased && (!i.parents || i.parents?.length === 0) && i.id !== this.state.contactId
            )
        })
    }

    show(contactId, data = null) {
        if (data) {
            data = {...data}
            this.setState({visible: true, edit: true, contactId: contactId, defaultData: data, id: data.id})
        } else {
            this.setState({visible: true, edit: false, contactId: contactId, defaultData: {}, id: null})
        }

        this.init()
    }

    close() {
        this.setState(this.initialState)
    }

    async onSubmit(data) {
        if (this.state.edit && !this.state.id) {
            notification.error({
                message: t`Erreur lors de l'édition`
            })
            this.close()
            return false
        }

        if (this.state.edit) {
            data.id = this.state.id
        }

        var res = await ApiService.post("/contact/rappel/hazkara/" + this.state.contactId, data)

        if (res.success) {
            notification.success({
                message: this.state.edit ? t`Édition réussie` : t`Ajout réussi`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: this.state.edit ? t`Erreur lors de l'édition` : t`Erreur lors de l'ajout`
            })
        }
    }

    render() {
        return (
            <Modal
                width="100%"
                title={this.state.edit ? t`Éditer un rappel d'hazakara` : t`Ajouter un rappel d'hazakara`}
                open={this.state.visible}
                destroyOnClose
                closable
                footer={null}
                onCancel={() => this.close()}
            >
                <PermissionAlert permissions={["contact.edit"]}>
                    <Form
                        ref={(ref) => this.form = ref}
                        initialValues={this.state.defaultData}
                        onFinish={(data) => this.onSubmit(data)}
                    >

                        <Form.Item
                            label={t`Contact à rappeler`}
                            name="contact"
                            rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                        >
                            <Select
                                placeholder={t`Contact à rappeler`}
                                showSearch
                                filterOption={(input, option) =>
                                    option.props.children.join().toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {this.state.contacts.map((item, index) => (
                                    <Option key={index} value={item.id}>
                                        <ContactIcon contact={item}/> {item.nom} {item.prenom} ({item.tel}) ({item.email})
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label={t`Texte libre`}
                            name="text"
                        >
                            <Input.TextArea placeholder={t`N'oubliez pas...`} style={{minHeight: "15vh"}}/>
                        </Form.Item>

                        <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                            <Button type="primary" htmlType="submit" loading={this.state.loading}>
                                <Trans>Valider</Trans>
                            </Button>
                        </Form.Item>

                    </Form>
                </PermissionAlert>
            </Modal>
        )
    }
}
